import React, { ComponentType, lazy, Suspense } from 'react'

/**
 * チャンク読み込みに失敗した際、エラーを握りつぶして null を描画する境界。
 *
 * react-loadable 時代の `loading: () => null`（読み込み中もエラー時も null を返し、
 * アプリシェルは生存させる）と同じ挙動を React.lazy で再現するためのもの。
 * これが無いと lazy の読み込み失敗が上位へ throw され、捕捉する ErrorBoundary が
 * 無いため React ルートごとアンマウント（全画面白）になる。
 */
class SwallowErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  render() {
    return this.state.hasError ? null : this.props.children
  }
}

/**
 * 動的 import したコンポーネントを遅延ロードするラッパーを生成する。
 * 読み込み失敗時は旧 react-loadable と同じく null を描画する（アプリは継続）。
 */
export const lazyRoute = (loader: () => Promise<{ default: ComponentType<any> }>) => {
  const LazyComponent = lazy(loader)

  const LazyRoute = (props: Record<string, unknown>) => (
    <SwallowErrorBoundary>
      <Suspense fallback={null}>
        <LazyComponent {...props} />
      </Suspense>
    </SwallowErrorBoundary>
  )

  return LazyRoute
}
